import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const SendMileageIndi2Component = React.lazy(
  () => import("../Components/RootComponents/SendMileageIndi2Component"),
);
const SendMileageIndi2Page = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <SendMileageIndi2Component />
      </Suspense>
    </Fragment>
  );
};

export default SendMileageIndi2Page;
